// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boarder {
  background-color: #23242A;
  height: 500px;
}

.footer {
  background-color: #23242A;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contact {
  background-color: #23242A;
  margin: 100px 200px;
}
.contact h2 {
  font-size: 14px;
}

.innerFooter {
  margin: 100px 90px;
}
.innerFooter h3 {
  color: #FFFFFF;
  font-size: 20px;
  margin-bottom: 340px;
  font-family: "Rakkas", cursive;
}
.innerFooter h5 {
  font-size: 12px;
}

@media (max-width: 425px) {
  .boarder {
    width: 100%;
  }

  .footer {
    width: 970px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/Footer.scss"],"names":[],"mappings":"AAEA;EACE,yBAHW;EAIX,aAAA;AADF;;AAKA;EACE,yBATW;EAUX,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAFF;;AAKA;EACE,yBAjBW;EAkBX,mBAAA;AAFF;AAGE;EACE,eAAA;AADJ;;AAMA;EACE,kBAAA;AAHF;AAIE;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,8BAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE;IACE,WAAA;EAJF;;EAOA;IACE,YAAA;EAJF;AACF","sourcesContent":["$footerColor:#23242A;\n\n.boarder{\n  background-color: $footerColor;\n  height: 500px;\n  \n}\n\n.footer{\n  background-color: $footerColor;\n  color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content:space-between;\n}\n\n.contact{\n  background-color: $footerColor;\n  margin:100px 200px;\n  h2{\n    font-size: 14px;\n  }\n\n}\n\n.innerFooter{\n  margin: 100px 90px;\n  h3{\n    color: #FFFFFF;\n    font-size: 20px;\n    margin-bottom: 340px;\n    font-family: 'Rakkas', cursive;\n    \n  }\n  h5{\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 425px){\n  .boarder{\n    width: 100%;\n  }\n\n  .footer{\n    width: 970px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
